export const CHAT_WIDGET_SCRIPT_TAG_ID = '__chatWidgetScriptTag';
export const CHAT_WIDGET_DIV_TAG_ID = '__chatWidgetDIVTag';
export const CHAT_WIDGET_MOUNT_ID = '__demo-chat-widget';
export const FETCH_APP_INFO_URL = `${process.env.REACT_APP_AUTH_API_URL}/v1/ai_assist/aiassistant/demo/usage`;
export const FETCH_DEMO_QUESTIONS_URL = (appId) =>
  `${process.env.REACT_APP_AUTH_API_URL}/v1/ai_assist/aiassistant/demo/questions/${appId}`;
export const BYPASS_EMAIL_AUTH = true;
export const CONSOLE_BASE_URL = process.env.REACT_APP_CONSOLE_BASE_URL || '';
